import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'gs0041',
    ecrans: ['00-2']
});
